import { render, staticRenderFns } from "./admin-sections.vue?vue&type=template&id=7d8eab0f"
import script from "./admin-sections.vue?vue&type=script&lang=js"
export * from "./admin-sections.vue?vue&type=script&lang=js"
import style0 from "./admin-sections.vue?vue&type=style&index=0&id=7d8eab0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports